import { Directive, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import * as ol from 'openlayers';
import { Draw } from './measureTool';

@Directive({
  selector: '[lDraw]'
})
export class DrawDirective {

  @Input('lDraw')
  public drawType: string;

  @Input()
  public map: ol.Map;

  @Input()
  public strokeColor: string;

  @Input()
  public fillColor: string;

  @Output()
  drawSartEvent: EventEmitter<any> = new EventEmitter();

  @Output()
  drawEndEvent: EventEmitter<any> = new EventEmitter();

  constructor(private _ele: ElementRef) { }

  @HostListener('click') onClick(event: Event) {
    this.drawSartEvent.emit();
    let draw: Draw = new Draw(this.drawType, e => { this.drawEndEvent.emit(e); draw = null; }, this.map);
  }

}
